import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { laseaAuthService } from '../../services/laseaAuthService';
import { laseaUserService } from '../../services/laseaUserService';
import QRScannerModal from './QRScannerModal';
import Icon from '../AppIcon';

export default function AdminHeader() {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState('');
  const [loading, setLoading] = useState(false);
  const [isScannerOpen, setIsScannerOpen] = useState(false);

  useEffect(() => {
    loadAdminProfile();
  }, []);

  const loadAdminProfile = async () => {
    try {
      const profile = await laseaUserService?.getCurrentUser();
      setAdminName(profile?.fullName);
    } catch (err) {
      console.error('Failed to load admin profile:', err);
    }
  };

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await laseaAuthService?.signOut();
      navigate('/admin-login');
    } catch (err) {
      console.error('Sign out failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleScanSuccess = (qrCodeData) => {
    // Navigate to the item details page
    // Assuming QR code contains the item ID
    navigate(`/edit-item-information/${qrCodeData}`);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between z-30">
        <div className="flex items-center">
          <h1
            className="text-xl font-bold text-foreground cursor-pointer hover:text-primary transition"
            onClick={() => navigate('/admin-dashboard')}
          >
            LaSea Admin Portal
          </h1>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setIsScannerOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition"
          >
            <Icon name="QrCode" size={20} />
            <span>Scan Item</span>
          </button>
          <span className="text-muted-foreground">Welcome, {adminName || 'Admin'}</span>
          <button
            onClick={handleSignOut}
            disabled={loading}
            className="px-4 py-2 bg-error text-error-foreground rounded-lg hover:bg-error/90 transition disabled:opacity-50"
          >
            {loading ? 'Signing out...' : 'Sign Out'}
          </button>
        </div>
      </header>

      <QRScannerModal
        isOpen={isScannerOpen}
        onClose={() => setIsScannerOpen(false)}
        onScanSuccess={handleScanSuccess}
      />
    </>
  );
}